// import { ValidateCheckbox } from "@/Checkbox";
// import DateButton from "@/common/DateButton";
// import { ValidateServiceCard } from "@/common/ServiceCard";
import { Divider } from "@/Divider";
import MessageModal from "@/MessageModal";
// import ToggleSwitch from "@/ToggleSwitch";
import { useEffect, useState, type ReactNode } from "react";
import { useForm } from "react-hook-form";
import useOpenModal from "^/common/useOpenModal";
import { CalendarNew as CalendarComponent } from "@/CalendarNew";
// import { Button } from "@/Button";
import { addDays } from "%/date";
import { PetDataType } from "~/types/common";
import {
  // useCalculateCoin,
  // useHasBalanceCoin,
  // useUpdateTempReserve,
  useUserReserve,
  // useUpdateUserReserve,
  // useCancelUserReserve,
} from "~/services/reservation";

// import { ValidateControllerSelect } from "@/ControllerSelect";
import { Dialog } from "@/Dialog";
// import ContractModal from "@/common/ContractModal";
import { useRouter } from "@tanstack/react-router";

interface ReservationClassState {
  storeName: string;
  storeType: string;
  content: string;
  weekly: boolean;
  day: string;
  services: string;
  animal: string;
  agree: boolean;
  startDate: Date | null;
  endDate: Date | null;
}

const ReservationChgClass = ({
  storeName,
  storeType,
  // storeData,
  petList,
  initialReservationSeq,
}: {
  storeName: string;
  storeType: string;
  storeData: { value: string; label: string };
  petList: PetDataType[];
  initialReservationSeq?: number;
}) => {
  const { history } = useRouter();
  const {
    // handleSubmit,
    // control,
    formState: { errors, isValid },
    watch,
    setValue,
  } = useForm<ReservationClassState>({
    defaultValues: {
      storeName: storeName,
      storeType: storeType,
      content: "",
      weekly: false,
      day: "",
      services: "",
      animal: "",
      agree: false,
      startDate: null,
      endDate: null,
    },
    mode: "onChange",
  });
  // const [ setDate] = useState(getToday());
  const { isOpenModal, closeModal } = useOpenModal();
  const [isStart] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  // const [showContractDialog, setShowContractDialog] = useState(false);
  // const [showContractModal, setShowContractModal] = useState(false);
  // const [contractMessage, setContractMessage] = useState("");
  const [showCoinShortageDialog, setShowCoinShortageDialog] = useState(false);
  const [showReservationCompleteDialog, setShowReservationCompleteDialog] =
    useState(false);
  const [showReservationCancelDialog, setShowReservationCancelDialog] =
    useState(false);
  const [, setReservationSeq] = useState<number | null>(null);
  const [, setIsUpdatable] = useState<boolean>(true);
  // const { usePetList,  } = usePet();
  // const { data: petList } = usePetList();

  // 예약 폼 API 연동: companySeq, cdProductType은 실제 상황에 맞게 수정 필요
  const [selectedPetSeq, setSelectedPetSeq] = useState<string | null>(
    petList && petList.length > 0 ? petList[0].petSeq.toString() : null
  );
  const [showGradeConfirmDialog, setShowGradeConfirmDialog] = useState(false);
  // const [gradeConfirm, setGradeConfirm] = useState(false); // 테스트를 위해 false로 설정

  // petList가 로드되면 첫 번째 반려동물을 자동으로 선택하고 폼 값도 설정
  // useEffect(() => {
  //   if (petList && petList.length > 0) {
  //     const firstPetSeq = petList[0].petSeq.toString();
  //     setSelectedPetSeq(firstPetSeq);
  //     setValue("animal", firstPetSeq, { shouldValidate: true });
  //   }
  // }, [petList, setValue]);

  // weekly 상태 감시
  const weeklyValue = watch("weekly");

  // weekly가 false로 변경될 때 endDate와 day 초기화
  useEffect(() => {
    if (!weeklyValue) {
      setValue("endDate", null, { shouldValidate: true });
      setValue("day", "", { shouldValidate: true });
    }
  }, [weeklyValue, setValue]);

  // const companySeq = 1; // 예시값, 실제로는 props 등에서 받아야 함
  // const cdProductType = "PRODUCT_TYPE_KINDERGARTEN";
  // const { data: reserveForms } = useReserveForms(
  //   parseInt(storeData.value),
  //   selectedPetSeq ? Number(selectedPetSeq) : 0,
  //   cdProductType,
  //   !!selectedPetSeq
  // );

  // 코인 계산 API 훅
  // const { mutate: calculateCoin } = useCalculateCoin();

  // // 예약 수정 API 훅
  // const { mutate: updateReserve, isPending: isUpdating } =
  //   useUpdateUserReserve();

  // // 예약 취소 API 훅
  // const { mutate: cancelReserve, isPending: isCanceling } =
  //   useCancelUserReserve();

  // // 임시 예약 업데이트 API 훅
  // const { mutate: updateTempReserve } = useUpdateTempReserve();

  // // 코인 잔액 확인 API 훅
  // const coinDiff = calculateCoinData?.data?.coinDiff || 0;
  // const { data: hasBalanceCoinData, isLoading: isCheckingBalance } =
  //   useHasBalanceCoin(coinDiff);

  // 기존 예약 정보 조회 API 훅
  const { data: existingReserveData } = useUserReserve({
    reservationSeq: initialReservationSeq || 0,
  });

  // 기존 예약 데이터를 폼 기본값으로 설정
  useEffect(() => {
    if (existingReserveData?.data) {
      const reserveData = existingReserveData.data;
      const reserveForm = reserveData.reserveForm;
      // 기본 폼 값 설정
      const startDateValue = new Date(reserveForm.dtReservStart);
      const endDateValue = reserveForm.dtReservEnd
        ? new Date(reserveForm.dtReservEnd)
        : null;
      console.log(endDateValue);
      console.log("startDateValue", startDateValue);
      console.log("endDateValue", endDateValue);
      setValue("startDate", startDateValue, {
        shouldValidate: true,
      });
      setValue("endDate", endDateValue, {
        shouldValidate: true,
      });

      // state도 함께 설정
      setStartDate(startDateValue);
      setEndDate(endDateValue);
      setValue("weekly", reserveForm.everyWeek, { shouldValidate: true });
      setValue("content", reserveForm.memo || "", { shouldValidate: true });

      // 선택된 반려동물 설정
      const selectedPet = reserveForm.pets.find((pet: any) => pet.select);
      if (selectedPet) {
        setSelectedPetSeq(selectedPet.petSeq.toString());
        setValue("animal", selectedPet.petSeq.toString(), {
          shouldValidate: true,
        });
      }

      // 요일 선택 설정
      const selectedDays = reserveForm.dayOfWeeks
        .filter((day: any) => day.select)
        .map((day: any) => day.cdDayOfWeek)
        .join(",");
      setValue("day", selectedDays, { shouldValidate: true });

      // 서비스 선택 설정
      const selectedServices = reserveForm.additionals
        .filter((service: any) => service.select)
        .map((service: any) => service.additionalCompanySeq.toString())
        .join(",");
      setValue("services", selectedServices, { shouldValidate: true });

      // reservationSeq 설정
      setReservationSeq(reserveData.reservationSeq);

      // updatable 상태 설정 ----예약수정 막기----
      // setIsUpdatable(reserveData.updatable);
      setIsUpdatable(false);
    }
  }, [existingReserveData, setValue]);

  // 폼 값들을 watch로 감지
  const watchedValues = watch();

  // 디버깅을 위한 로그
  console.log("=== 폼 상태 디버깅 ===");
  console.log("agree value:", watchedValues.agree);
  console.log("agree error:", errors.agree);
  console.log("startDate value:", watchedValues.startDate);
  console.log("endDate value:", watchedValues.endDate);
  console.log("animal value:", watchedValues.animal);
  console.log("isValid:", isValid);
  console.log("전체 errors:", errors);
  console.log("전체 watchedValues:", watchedValues);
  console.log("=== 디버깅 끝 ===");

  // 코인 계산 API 호출 함수
  // const callCalculateCoin = () => {
  //   if (!existingReserveData) return;
  //   console.log(existingReserveData);
  //   // 선택된 반려동물 찾기
  //   const selectedPet = petList?.find(
  //     (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq
  //   );
  //   if (!selectedPet) return;

  //   // 요청 데이터 구성
  //   const requestData = {
  //     reservationSeq: existingReserveData.data.reservationSeq,
  //     cdProductType: cdProductType,
  //     gradeConfirm: existingReserveData.data.gradeConfirm,
  //     paymentCoinTotal: existingReserveData.data.paymentCoinTotal,
  //     companySeq: existingReserveData.data.companySeq,
  //     reserveForm: {
  //       productSeq: existingReserveData.data.reserveForm.productSeq, // 기본값 설정
  //       dtReservStart: watchedValues.startDate
  //         ? formatDate(watchedValues.startDate)
  //         : null,
  //       dtReservEnd: watchedValues.endDate
  //         ? formatDate(watchedValues.endDate)
  //         : null,
  //       dayOfWeeks: [
  //         {
  //           cdDayOfWeek: "MONDAY",
  //           dayOfWeekName: "월요일",
  //           select: watchedValues.day?.includes("MONDAY") || false,
  //         },
  //         {
  //           cdDayOfWeek: "TUESDAY",
  //           dayOfWeekName: "화요일",
  //           select: watchedValues.day?.includes("TUESDAY") || false,
  //         },
  //         {
  //           cdDayOfWeek: "WEDNESDAY",
  //           dayOfWeekName: "수요일",
  //           select: watchedValues.day?.includes("WEDNESDAY") || false,
  //         },
  //         {
  //           cdDayOfWeek: "THURSDAY",
  //           dayOfWeekName: "목요일",
  //           select: watchedValues.day?.includes("THURSDAY") || false,
  //         },
  //         {
  //           cdDayOfWeek: "FRIDAY",
  //           dayOfWeekName: "금요일",
  //           select: watchedValues.day?.includes("FRIDAY") || false,
  //         },
  //         {
  //           cdDayOfWeek: "SATURDAY",
  //           dayOfWeekName: "토요일",
  //           select: watchedValues.day?.includes("SATURDAY") || false,
  //         },
  //         {
  //           cdDayOfWeek: "SUNDAY",
  //           dayOfWeekName: "일요일",
  //           select: watchedValues.day?.includes("SUNDAY") || false,
  //         },
  //       ],
  //       paymentCoin: existingReserveData.data.reserveForm.paymentCoin,
  //       additionals: existingReserveData.data.reserveForm.additionals.map(
  //         (additional: {
  //           additionalCompanySeq?: number;
  //           additionalName: string;
  //           paymentCoin: number;
  //         }) => ({
  //           ...additional,
  //           active: true, // 기본값 설정
  //           select:
  //             watchedValues.services?.includes(
  //               additional.additionalCompanySeq?.toString() || ""
  //             ) || false,
  //         })
  //       ),
  //       pets: existingReserveData.data.reserveForm.pets,
  //       memo: null,
  //       ...(watchedValues.weekly && { everyWeek: watchedValues.weekly }),
  //     },
  //   };

  //   console.log("코인 계산 API 호출:", requestData);
  //   const result = calculateCoin(requestData);
  //   console.log(result);
  // };

  // 조건에 따라 코인 계산 API 호출 (비활성화)
  // useEffect(() => {
  //   // 1. 등원일을 날짜를 2개다 선택했을 때
  //   // 2. 매주등원스위치를 누르고 요일을 선택했을 때
  //   // 3. 매주등원스위치를 false로 했을 때
  //   // 4. 부가서비스를 선택했을 때

  //   const hasBothDates = watchedValues.startDate;
  //   const hasPetSelected = selectedPetSeq;

  //   if (hasBothDates && hasPetSelected && existingReserveData) {
  //     callCalculateCoin();
  //   }
  // }, [
  //   watchedValues.startDate,
  //   watchedValues.endDate,
  //   watchedValues.weekly,
  //   watchedValues.day,
  //   watchedValues.services,
  //   existingReserveData,
  // ]);

  // petList가 변경될 때 첫 번째 반려동물로 초기화
  // (선택 유지하고 싶으면 이 부분은 생략)
  // useEffect(() => {
  //   if (petList && petList.length > 0) setSelectedPetSeq(petList[0].petSeq.toString());
  // }, [petList]);
  // const handleDateClick = (isNext: boolean) => {
  //   if (!isUpdatable) return; // 수정 불가능한 경우 클릭 무시

  //   if (isNext) {
  //     setIsStart(true);
  //   } else {
  //     setIsStart(false);
  //   }
  //   clickModal();
  //   // 달력 모달 열기 로직
  //   // alert("여기에 달력 모달을 띄우세요!");
  // };

  const handleDaySelect = (isStart: boolean, day: Date | null) => {
    if (!day) return;

    // const formattedDate = formatDate(day);

    if (isStart) {
      // console.log("startDate", day);
      setValue("startDate", day, { shouldValidate: true });
      setStartDate(day);
      // setDate(formattedDate);
    } else {
      setValue("endDate", day, { shouldValidate: true });
      setEndDate(day);
      // setDate(formattedDate);
    }
  };

  // const bindSubmit = (data: ReservationClassState) => {
  //   console.log("예약 데이터:", data);

  //   if (!existingReserveData) {
  //     console.error("필수 데이터가 없습니다.");
  //     return;
  //   }

  //   // gradeConfirm 체크
  //   if (!existingReserveData.data.gradeConfirm) {
  //     console.error("해당 반려견의 체급은 수용이 불가능합니다.");
  //     setShowGradeConfirmDialog(true);
  //     return;
  //   }

  //   // 코인 잔액 확인
  //   if (isCheckingBalance) {
  //     console.log("코인 잔액 확인 중...");
  //     return;
  //   }

  //   if (hasBalanceCoinData) {
  //     console.log("코인 잔액 확인 결과:", hasBalanceCoinData);

  //     // 코인 잔액이 부족한 경우 처리
  //     if (!hasBalanceCoinData.data.coinPurchasable) {
  //       console.error("코인 잔액이 부족합니다.");
  //       setShowCoinShortageDialog(true);
  //       return;
  //     }
  //   }

  //   // // 선택된 반려동물 찾기
  //   // const selectedPet = petList?.find(
  //   //   (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq
  //   // );
  //   // if (!selectedPet) {
  //   //   console.error("선택된 반려동물을 찾을 수 없습니다.");
  //   //   return;
  //   // }

  //   // 예약 생성 요청 데이터 구성
  //   const requestData: any = {
  //     reservationSeq: existingReserveData.data.reservationSeq,
  //     cdProductType: cdProductType,
  //     gradeConfirm: existingReserveData.data.gradeConfirm,
  //     paymentCoinTotal: calculateCoinData?.data?.paymentCoinTotal || null,
  //     companySeq: existingReserveData.data.companySeq,
  //     reserveForm: {
  //       productSeq: existingReserveData.data.reserveForm.productSeq,
  //       dtReservStart: data.startDate ? formatDate(data.startDate) : null,
  //       dtReservEnd: data.endDate ? formatDate(data.endDate) : null,
  //       dayOfWeeks: data.weekly
  //         ? [
  //             {
  //               cdDayOfWeek: "MONDAY",
  //               dayOfWeekName: "월요일",
  //               select: data.day?.includes("MONDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "TUESDAY",
  //               dayOfWeekName: "화요일",
  //               select: data.day?.includes("TUESDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "WEDNESDAY",
  //               dayOfWeekName: "수요일",
  //               select: data.day?.includes("WEDNESDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "THURSDAY",
  //               dayOfWeekName: "목요일",
  //               select: data.day?.includes("THURSDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "FRIDAY",
  //               dayOfWeekName: "금요일",
  //               select: data.day?.includes("FRIDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "SATURDAY",
  //               dayOfWeekName: "토요일",
  //               select: data.day?.includes("SATURDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "SUNDAY",
  //               dayOfWeekName: "일요일",
  //               select: data.day?.includes("SUNDAY") || false,
  //             },
  //           ]
  //         : [],
  //       paymentCoin: existingReserveData.data.reserveForm.paymentCoin,
  //       additionals: existingReserveData.data.reserveForm.additionals.map(
  //         (additional: {
  //           additionalCompanySeq?: number;
  //           additionalName: string;
  //           paymentCoin: number;
  //         }) => ({
  //           ...additional,
  //           active: true,
  //           select:
  //             data.services?.includes(
  //               additional.additionalCompanySeq?.toString() || ""
  //             ) || false,
  //         })
  //       ),
  //       pets: existingReserveData.data.reserveForm.pets,
  //       memo: data.content || null,
  //       ...(data.weekly && { everyWeek: data.weekly }),
  //     },
  //   };

  //   console.log("예약 생성 API 호출:", requestData);

  //   updateReserve(requestData, {
  //     onSuccess: (response: any) => {
  //       console.log("예약 생성 응답:", response);
  //       if (response.statusCode === 200) {
  //         // responseCode 확인
  //         if (
  //           response.data?.responseCode === "KINDERGARTEN_RESERVE_REQUESTED"
  //         ) {
  //           // 예약 성공 시 update-temp API 호출
  //           // if (response.data?.reservationSeq) {
  //           //   updateTempReserve({
  //           //     reservationSeq: response.data.reservationSeq,
  //           //     contractCancel: false,
  //           //   });
  //           // }
  //         } else if (response.data?.responseCode === "INVALID_CONTRACT") {
  //           // 계약이 필요한 경우
  //           setReservationSeq(response.data?.reservationSeq || null);
  //           setContractMessage(response.message || "계약이 필요합니다.");
  //           setShowContractDialog(true);
  //         } else {
  //           // 정상 성공인 경우
  //           setShowReservationCompleteDialog(true);
  //           // alert("예약이 성공적으로 완료되었습니다.");
  //           // history.push("/reservation/success");
  //         }
  //       }
  //     },
  //     onError: (error: unknown) => {
  //       console.error("예약 생성 실패:", error);
  //       alert("예약 생성에 실패했습니다. 다시 시도해주세요.");
  //     },
  //   });
  // };

  // // 예약 취소 함수
  // const handleCancelReservation = () => {
  //   if (!initialReservationSeq) {
  //     console.error("예약 번호가 없습니다.");
  //     return;
  //   }

  //   cancelReserve(existingReserveData ? existingReserveData.data : {}, {
  //     onSuccess: (response: any) => {
  //       console.log("예약 취소 응답:", response);
  //       if (response.statusCode === 200) {
  //         setShowReservationCancelDialog(true);
  //       }
  //     },
  //     onError: (error: unknown) => {
  //       console.error("예약 취소 실패:", error);
  //       alert("예약 취소에 실패했습니다. 다시 시도해주세요.");
  //     },
  //   });
  // };

  // 예약 유형 텍스트 변환
  // const getReservationTypeText = (cdProductType: string) => {
  //   switch (cdProductType) {
  //     case "PRODUCT_TYPE_KINDERGARTEN":
  //       return "수업";
  //     case "PRODUCT_TYPE_DAYCARE":
  //       return "데이케어";
  //     case "PRODUCT_TYPE_HOTEL":
  //       return "호텔";
  //     case "PRODUCT_TYPE_GROOMING":
  //       return "미용";
  //     default:
  //       return "예약";
  //   }
  // };

  // 선택된 반려동물 정보
  const selectedPet = petList?.find(
    (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq
  );

  // 날짜 포맷팅
  const formatDisplayDate = (date: Date | null) => {
    if (!date) return "";
    return date.toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  if (!existingReserveData?.data) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="text-gray-500">예약 정보를 불러오는 중...</div>
      </div>
    );
  }

  const reserveData = existingReserveData.data;
  const reserveForm = reserveData.reserveForm;
  const isCanceled = reserveData.cdReservStatus === "RESERV_STATUS_CANCELED";

  // 선택된 요일 / 부가 서비스
  const selectedDayNames = (reserveForm.dayOfWeeks || [])
    .filter((d) => d.select)
    .map((d) => d.dayOfWeekName);
  const selectedAdditionals = (reserveForm.additionals || []).filter(
    (a) => a.select
  );

  // 시작·종료 같은 날 여부
  const isSameDay =
    !!startDate &&
    !!endDate &&
    formatDisplayDate(startDate) === formatDisplayDate(endDate);

  // 메모 유효성
  const memoText = (reserveForm.memo || "").trim();
  const hasMemo = memoText.length > 0;

  // 잔여 회수 계산
  const ticketInfo = reserveData.ticketInfo;
  const hasTicketQty =
    !!ticketInfo &&
    typeof ticketInfo.totalQty === "number" &&
    typeof ticketInfo.remainQty === "number";
  const usedQty = hasTicketQty
    ? (ticketInfo!.totalQty as number) - (ticketInfo!.remainQty as number)
    : 0;
  const remainQty = hasTicketQty ? (ticketInfo!.remainQty as number) : 0;

  // 예약 유형 한글 라벨 (라우트의 fnReservationName 이관)
  const reservationTypeLabel = (() => {
    switch (storeType) {
      case "RESERV_TYPE_CLASS":
        return "유치원";
      case "RESERV_TYPE_DAYCARE":
        return "데이케어";
      case "RESERV_TYPE_HOTEL":
        return "호텔";
      case "RESERV_TYPE_GROOMING":
        return "미용";
      default:
        return "";
    }
  })();

  // 공용 카드 스타일 — 모든 섹션에 동일 적용해 통일감 부여
  const cardClass =
    "p-4 bg-white rounded-2xl border border-orange-100 shadow-[0_1px_2px_rgba(0,0,0,0.04)]";
  const titleClass =
    "mb-2 text-[11px] font-bold tracking-[0.08em] text-orange-500 uppercase";

  // 보조 정보 섹션 (반려동물·메모·부가서비스 등) 공용 컨테이너
  const Section = ({
    title,
    children,
    headerSlot,
  }: {
    title: string;
    children: ReactNode;
    headerSlot?: ReactNode;
  }) => (
    <section className={cardClass}>
      {headerSlot ? (
        <div className="flex justify-between items-center">
          <h3 className={titleClass}>{title}</h3>
          {headerSlot}
        </div>
      ) : (
        <h3 className={titleClass}>{title}</h3>
      )}
      {children}
    </section>
  );

  return (
    <>
      {/* 카드들이 따로 놀지 않도록 동일 톤(흰 카드 + 옅은 오렌지 라인) + 일정 간격(gap-2.5)으로 묶고,
          섹션 타이틀만 오렌지 액센트로 통일 */}
      <div className="flex flex-col gap-2.5 pb-4">
        {/* 0. 취소된 예약 안내 — 취소돼도 예약했던 날짜·시간을 확인할 수 있게 상세는 그대로 보여준다 */}
        {isCanceled && (
          <div className="flex gap-2.5 items-start p-4 bg-gray-100 rounded-2xl border border-gray-200">
            <span className="flex-shrink-0 px-2.5 py-0.5 text-[11px] font-semibold text-gray-600 bg-white rounded-full border border-gray-300">
              예약취소
            </span>
            <p className="text-sm leading-relaxed text-gray-600 break-keep">
              취소된 예약이에요. 아래 내용은 취소 전 예약했던 정보예요.
            </p>
          </div>
        )}
        {/* 1. 반려동물 */}
        {selectedPet && (
          <Section title="반려동물">
            <div className="flex gap-3 items-center">
              <div className="flex-shrink-0">
                {selectedPet.fileUrl ? (
                  <img
                    src={selectedPet.fileUrl}
                    alt={selectedPet.petName || ""}
                    className="object-cover w-14 h-14 rounded-full border border-orange-100"
                  />
                ) : (
                  <div className="flex justify-center items-center w-14 h-14 bg-orange-50 rounded-full">
                    <svg
                      className="w-7 h-7 text-orange-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-base font-semibold text-gray-900 truncate">
                  {selectedPet.petName}
                </div>
                <div className="flex flex-wrap gap-x-2 gap-y-0.5 mt-0.5 text-xs text-gray-500">
                  {selectedPet.petBreedName && (
                    <span>{selectedPet.petBreedName}</span>
                  )}
                  {selectedPet.petBreedName && selectedPet.petWeight ? (
                    <span className="text-gray-300">·</span>
                  ) : null}
                  {selectedPet.petWeight ? (
                    <span>{selectedPet.petWeight}kg</span>
                  ) : null}
                </div>
              </div>
            </div>
          </Section>
        )}

        {/* 2. 이용 업체 */}
        <Section
          title="이용 업체"
          headerSlot={
            reservationTypeLabel ? (
              <span className="px-2.5 py-0.5 text-[11px] font-semibold text-orange-600 bg-orange-50 rounded-full">
                {reservationTypeLabel}
              </span>
            ) : undefined
          }
        >
          <div className="mt-0.5">
            <div className="text-base font-semibold text-gray-900 break-keep">
              {storeName || ticketInfo?.companyName || "-"}
            </div>
            {ticketInfo?.address && (
              <div className="mt-1 text-xs leading-relaxed text-gray-500 break-keep">
                {ticketInfo.address}
              </div>
            )}
          </div>
        </Section>

        {/* 3. 예약 일정 */}
        <Section
          title="예약 일정"
          headerSlot={
            reserveForm.everyWeek ? (
              <span className="px-2.5 py-0.5 text-[11px] font-semibold text-orange-600 bg-orange-50 rounded-full">
                매주 반복
              </span>
            ) : undefined
          }
        >
          {isSameDay ? (
            <div className="text-lg font-bold leading-tight text-gray-900">
              {formatDisplayDate(startDate)}
            </div>
          ) : (
            <div className="flex flex-wrap gap-x-2 gap-y-1 items-baseline">
              <span className="text-lg font-bold text-gray-900">
                {formatDisplayDate(startDate)}
              </span>
              {endDate && (
                <>
                  <span className="text-sm text-gray-400">~</span>
                  <span className="text-lg font-bold text-gray-900">
                    {formatDisplayDate(endDate)}
                  </span>
                </>
              )}
            </div>
          )}
          {selectedDayNames.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-3">
              {selectedDayNames.map((name) => (
                <span
                  key={name}
                  className="px-2.5 py-1 text-xs font-medium text-orange-600 bg-orange-50 rounded-full"
                >
                  {name}
                </span>
              ))}
            </div>
          )}
        </Section>

        {/* 4. 사용 이용권 */}
        {ticketInfo && (
          <Section title="사용 이용권">
            <div className="flex gap-3 justify-between items-start">
              <div className="flex-1 min-w-0">
                <div className="text-base font-semibold leading-tight text-gray-900 break-keep">
                  {ticketInfo.name}
                </div>
                {ticketInfo.badge && ticketInfo.badge.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-1.5">
                    {ticketInfo.badge.map((badge: string, idx: number) => (
                      <span
                        key={idx}
                        className="px-2 py-0.5 text-[11px] font-medium text-orange-600 bg-orange-50 rounded-full"
                      >
                        {badge}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              {typeof ticketInfo.amount === "number" && (
                <div className="flex-shrink-0 text-right">
                  <div className="text-[11px] text-gray-500">결제 금액</div>
                  <div className="text-base font-bold text-orange-600">
                    {ticketInfo.amount.toLocaleString()}
                    <span className="ml-0.5 text-xs font-medium text-orange-500">
                      원
                    </span>
                  </div>
                </div>
              )}
            </div>

            {(hasTicketQty || ticketInfo.expiredDate) && (
              <div className="grid grid-cols-2 gap-3 pt-3 mt-3 border-t border-gray-100">
                {hasTicketQty && (
                  <div>
                    <div className="text-[11px] text-gray-500">사용 현황</div>
                    <div className="mt-0.5 text-sm font-semibold text-gray-800">
                      <span>{usedQty}회 사용</span>
                      <span
                        className={
                          remainQty === 0
                            ? "ml-1 font-normal text-gray-400"
                            : "ml-1 text-orange-500"
                        }
                      >
                        ({remainQty}회 남음)
                      </span>
                    </div>
                  </div>
                )}
                {ticketInfo.expiredDate && (
                  <div className={hasTicketQty ? "text-right" : ""}>
                    <div className="text-[11px] text-gray-500">만료일</div>
                    <div className="mt-0.5 text-sm font-semibold text-gray-800">
                      {ticketInfo.expiredDate}
                    </div>
                  </div>
                )}
              </div>
            )}
          </Section>
        )}

        {/* (옵션) 부가 서비스 — 선택된 항목 있을 때만 */}
        {selectedAdditionals.length > 0 && (
          <Section title="부가 서비스">
            <ul className="divide-y divide-gray-100">
              {selectedAdditionals.map((item) => (
                <li
                  key={item.additionalCompanySeq}
                  className="flex justify-between items-center py-2"
                >
                  <span className="text-sm text-gray-800">
                    {item.additionalName}
                  </span>
                  {typeof item.paymentCoin === "number" &&
                    item.paymentCoin > 0 && (
                      <span className="text-xs font-medium text-gray-500">
                        {item.paymentCoin.toLocaleString()} 멍코인
                      </span>
                    )}
                </li>
              ))}
            </ul>
          </Section>
        )}

        {/* (옵션) 메모 — 있을 때만 */}
        {hasMemo && (
          <Section title="메모">
            <p className="text-sm leading-relaxed text-gray-700 whitespace-pre-wrap break-keep">
              {memoText}
            </p>
          </Section>
        )}
      </div>
      <Divider className="mt-auto" line />
      {/* 하단 확인 버튼 */}
      <div className="w-full px-4 py-4 bg-[#F5F5F5]">
        <button
          onClick={() => history.back()}
          className="py-3 w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full"
        >
          확인
        </button>
      </div>
      {/* <div className="flex justify-between pt-5 pb-3 text-[#999] text-[13px] leading-[16.9px]">
        예약정보는 예약일 1일 전까지만 수정 및 취소 할 수 있습니다. 예약 당일
        서비스 미 이용 시에도 이용권은 자동으로 소진됩니다.예약 확정은
        위탁사업자 확인 후 이루어집니다.
      </div>
      <div className="flex justify-end my-5 mr-2">
        <Controller
          name="agree"
          control={control}
          rules={{ required: "확인 및 동의가 필요합니다." }}
          render={({ field }) => (
            <ValidateCheckbox
              defaultChecked={field.value}
              onChange={() => field.onChange(!field.value)}
              disabled={!isUpdatable}
              title="확인 및 동의"
            />
          )}
        />
      </div>
      {isUpdatable && (
        <div className="w-full px-2 pb-6 bg-[#F5F5F5] pt-10 grid grid-cols-1 gap-5">
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={!isValid || isUpdating || !isUpdatable}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
              {calculateCoinData?.data?.coinDiff
                ? calculateCoinData?.data?.coinDiff +
                  "멍코인 결제 후 예약 정보 수정"
                : "예약 정보 수정"}
            </div>
          </Button>
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleCancelReservation}
            disabled={isCanceling || !isUpdatable}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-orange-400 bg-white rounded-full border border-orange-400">
              {isCanceling ? "취소 중..." : "예약 취소"}
            </div>
          </Button>
        </div>
      )}
      {!isUpdatable && (
        <div className="w-full px-2 pb-6 bg-[#F5F5F5] pt-10 grid grid-cols-1 gap-5">
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={true}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-[#999] rounded-full">
              예약 정보 수정 불가
            </div>
          </Button>
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit(bindSubmit)}
            disabled={true}
          >
            <div className="py-3 mx-auto w-full text-base font-semibold text-center text-[#999] bg-white rounded-full border border-[#999]">
              예약 취소 불가
            </div>
          </Button>
        </div>
      )} */}

      {/* 달력 모달 */}
      <MessageModal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        shouldCloseOnOverlayClick={false}
      >
        <CalendarComponent
          disabled={false}
          dayOnClick={(day) => {
            handleDaySelect(isStart, day);
          }}
          selectedDay={isStart ? startDate : endDate}
          disablePast={true} // startDate 선택 시 오늘 이후만 선택 가능
          minDate={
            isStart ? undefined : startDate ? addDays(startDate, 1) : undefined
          } // endDate 선택 시 startDate 다음날부터 선택 가능
          readOnlyDates={isStart ? [] : startDate ? [startDate] : []} // endDate 선택 시 startDate를 읽기 전용으로 표시
          schedules={{}}
        />
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={closeModal}
          >
            확인
          </button>
        </div>
      </MessageModal>
      {/* 달력 모달 */}
      {/* 예약 폼 데이터 확인용 디버깅 */}
      {/* {isFormsLoading && <div>예약 폼 로딩중...</div>}
      {reserveForms && (
        <pre style={{ background: '#f5f5f5', padding: 10, margin: 10 }}>{JSON.stringify(reserveForms, null, 2)}</pre>
      )} */}

      {/* 계약 관련 다이얼로그 */}
      {/* <Dialog
        visible={showContractDialog}
        onClose={() => {
          setShowContractDialog(false);
          // onClose 이벤트 시 updateTempReserve 호출
          if (reservationSeq) {
            updateTempReserve({
              reservationSeq,
              contractCancel: true,
            });
          }
        }}
      >
        <div className="p-4">
          <p className="mb-4 text-center">{contractMessage}</p>
          <div className="flex gap-2">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={() => {
                setShowContractDialog(false);
                // 취소 버튼 클릭 시 updateTempReserve 호출
                if (reservationSeq) {
                  updateTempReserve({
                    reservationSeq,
                    contractCancel: true,
                  });
                }
              }}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={() => {
                setShowContractDialog(false);
                setShowContractModal(true);
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog> */}

      {/* 계약 모달 */}
      {/* <ContractModal
        visible={showContractModal}
        onClose={() => setShowContractModal(false)}
        onConfirm={() => {
          updateTempReserve({
            reservationSeq: reservationSeq || 0,
            contractCancel: false,
          });
          setShowContractModal(false);
          setShowReservationCompleteDialog(true);
        }}
        selectedPet={petList?.find(
          (pet) => pet.petSeq.toString() === selectedPetSeq
        )}
        reservationSeq={reservationSeq || undefined}
        companySeq={parseInt(storeData.value)}
        // userSeq={1} // TODO: 실제 사용자 정보에서 가져오기
      /> */}

      {/* 체급 확인 다이얼로그 */}
      <Dialog
        visible={showGradeConfirmDialog}
        onClose={() => setShowGradeConfirmDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">체급 수용 불가</h3>
          <p className="mb-6 text-sm text-gray-600">
            해당 반려견의 체급은 수용이 불가능합니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => setShowGradeConfirmDialog(false)}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 코인 부족 다이얼로그 */}
      <Dialog
        visible={showCoinShortageDialog}
        onClose={() => setShowCoinShortageDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">멍코인이 모자라요</h3>
          <p className="mb-6 text-sm text-gray-600">
            멍코인 구매 페이지로 이동합니다.
          </p>
          <div className="flex gap-3">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-white rounded-full border border-gray-300"
              onClick={() => setShowCoinShortageDialog(false)}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowCoinShortageDialog(false);
                history.push("/customer/layout/user-buy-coin");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 예약 완료 다이얼로그 */}
      <Dialog
        visible={showReservationCompleteDialog}
        onClose={() => setShowReservationCompleteDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">예약 정보 수정 완료</h3>
          <div className="p-3 mb-4 bg-gray-100 rounded-full bg-[#F5F5F5] max-w-[200px] mx-auto">
            <span className="font-bold text-black">
              {startDate && endDate
                ? `${startDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")} ~ ${endDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}`
                : new Date()
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}
            </span>
          </div>
          <p className="mb-6 text-sm text-gray-600">
            수업 예약의 정보가 변경되었습니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowReservationCompleteDialog(false);
                history.push("/customer/layout/calendar");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={showReservationCancelDialog}
        onClose={() => setShowReservationCancelDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">예약 취소 완료</h3>
          <div className="p-3 mb-4 bg-gray-100 rounded-full bg-[#F5F5F5] max-w-[200px] mx-auto">
            <span className="font-bold text-black">
              {startDate
                ? startDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")
                : new Date()
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}
            </span>
          </div>
          <p className="mb-6 text-sm text-gray-600">
            수업 예약이 취소되었습니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowReservationCancelDialog(false);
                history.push("/customer/layout/calendar");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default ReservationChgClass;
